export default "__VITE_ASSET__D$w3h2e1__"